import React, { useState, useEffect, Suspense } from 'react';
import Game from '../../../../class/Game/Game';
import Games from '../../../../class/Game_copy/Game';

import ModalLogin from '../../modal/modal_login.js';
import { useTranslation } from 'react-i18next';



import {openGameModal} from '../../modal/modal_game';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

const ProviderGames = ({ provider, user_id, cetegory, AuthService, isLogged, setIsLoginModalOpen }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();



  const updateFavoriteGame = async (newGameId ) => {
    if (isLogged) {
      try {
        // Получаем инфу об игре
        const gameInfo = await Games.getGameInfo(newGameId);
        const gameType = gameInfo?.params?.game_info[0]?.category_slug || '';

        const user_id = await AuthService.getCustom('user_id');
        const lastGames = await Games.updateFavoriteGames(user_id, gameType, newGameId );
        
        // console.log("NUOVO GIOCO PREFERITO");
        // console.log(lastGames);

      } catch (error) {
        console.error('Failed to fetch game info or open game:', error);
      }
    } else if (!isLogged) {
      setIsLoginModalOpen(true);
      console.error(t('User_is_not_logged_in.'));
    }

    // console.log('ModalGame opened with gameId:', [newGameId, isLogged]);
  };


  useEffect(() => {
    const fetchGames = async () => {

  
      try {
        const gamesData = await Games.getProviderGame(user_id, provider.id, 20, 1, cetegory);

        setGames(gamesData.params.games);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching games:', error);
        setLoading(false);
      }
    };

    fetchGames();
  }, [provider.id, user_id, cetegory]);

  
  const getProviderIcon = (providerslug) => {
    return `${cmsUrl}static-assets/providers/${providerslug}.png`;
};

  const renderLoadingGames = () => {
    return Array.from({ length: 4 }).map((_, index) => (
      <div key={index} className="HomeSectionCasinoGames_game" >
        <div className="CasinoGameCard_root" >
          <div className="CasinoGamePreview_root blurred" >
            <div className="CasinoGamePreview_gradient"></div>
            <img
                  className="ResponsivePicture_img CasinoGamePreview_image"
                  src="https://storage.googleapis.com/camasy-images/casino/only__play__619cb11478244.png"
               
              
                  style={{
           
                    filter: 'blur(10px)',
                  
                }}
            />
          </div>
          <div className="CasinoGameCard_info CasinoGameCard_withProvider">
            <div className="CasinoGameCard_provider">
              <div className="CasinoGameCard_icon_placeholder"></div>
              <p className="CasinoGameCard_name_placeholder"   style={{
           
           filter: 'blur(10px)',
         
       }}>Loading...</p>
            </div>
            <p className="CasinoGameCard_gameName_placeholder"   style={{
           
           filter: 'blur(10px)',
         
       }}>Loading...</p>
          </div>
        </div>
      </div>
    ));
  };

  return (
    
    <>
      {loading ? (
        renderLoadingGames()
      ) : (
        
        games.map(game => (
       
          <div key={game.id} className="HomeSectionCasinoGames_game"  >
            <div className="CasinoGameCard_root">
              <div className={`CasinoGamePreview_root ${loading ? 'blurred' : ''}`} onClick={() => openGameModal(game.id)}>
                <div className="CasinoGamePreview_gradient"></div>
                <img
                  className="ResponsivePicture_img CasinoGamePreview_image"
                  src={game.thumbnail || 'default-image.jpg'}
                  alt={game.name}
                  loading="lazy"
                />
              </div>
              <div className="CasinoGameCard_info CasinoGameCard_withProvider">
                <div className="CasinoGameCard_provider">
                  <img
                    alt={provider.name}
                    src={getProviderIcon(provider.slug)}
                    className="CasinoGameCard_icon"
                    onClick={() => openGameModal(game.id)}
                  />
                  <p className="CasinoGameCard_name" onClick={() => openGameModal(game.id)}>{provider.name}</p>
                  <button style={{zIndex: "100", width: "12%", position: "absolute", height: "12%",left: "80%"}} onClick={
                    () => {
                      if(isLogged){
                        updateFavoriteGame(game.id);
                        setGames(prev =>
                          prev.map(g =>
                            g.id === game.id
                              ? { ...g, favorite: Number(g.favorite) == 1 ? 0 : 1 }
                              : g
                          )
                        );
                      } else{
                        setIsLoginModalOpen(true);
                      }
                    }  
                  }>
                    <svg className="" viewBox='0 0 50 50'>
                      <path d="M38.7,8.9c-4.4-2.4-10.2-1.7-13.8,1.6c-3.7-3.3-9.4-4-13.9-1.6C7.2,11,4.8,15,4.8,19.4
                        c0,1.2,0.2,2.5,0.6,3.5c1.9,8.6,18,18.8,18.7,19.2l0.8,0.5l0.8-0.5c0.7-0.4,16.7-10.6,18.6-19c0.4-1.2,0.6-2.4,0.6-3.7 
                        C44.8,15,42.5,11,38.7,8.9z" fill={(Number(game.favorite) == 1) ? "red" : "transparent"} style={{ stroke: "red", strokeWidth: "4px" }}
                      />
                    </svg>

                  </button>
                </div>
                <p className="CasinoGameCard_gameName">{game.name}</p>
              </div>
            </div>
       
          </div>
        ))
      )}


    </>
  );
};

export default ProviderGames;
